<template>
  <NuxtLayout name="default">
    <template #menu>
      <smart-page-edit-block-menu></smart-page-edit-block-menu>
    </template>
    <SmartPage editable />
  </NuxtLayout>
</template>

<script lang="ts">
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()

    definePageMeta({
      layout: false
    })

    return { userStore }
  },

  computed: {
    hasValidRole() {
      return ["admin", "content_admin", "content_creator", "field_leader"].includes(
        this.userStore.current?.role
      )
    },
  },

  created() {
    if (!this.hasValidRole) {
      navigateTo("/")
    }
  },
}
</script>
